import { green, orange, pink } from 'bold-ui/lib/styles/colors'
import {
  ClassificacaoVulnerabilidadeFamiliar,
  GrauSugestivoVulnerabilidadeFamiliar,
  ProntuarioFamiliarQuery,
  ProntuarioFamiliarVisitasDomiciliaresQuery,
} from 'graphql/types.generated'

import IconeVisitaFamiliar from '../../../../images/prontuario-familiar/icone-visita_familiar.svg'
import IconeVisitaIndefinida from '../../../../images/prontuario-familiar/icone-visita_indefinida.svg'
import IconeVisitaIndividual from '../../../../images/prontuario-familiar/icone-visita_individual.svg'

export type ProntuarioFamiliarVisitaModel = ProntuarioFamiliarVisitasDomiciliaresQuery['visitas']['content'][0]

export type ProntuarioFamiliarFamiliaModel = ProntuarioFamiliarQuery['cidadao']['familias'][number]

export enum TipoVisitaDomiciliarEnum {
  INDIVIDUAL = 1,
  FAMILIAR = 2,
  INDEFINIDA = null,
}

interface VisitaDomiciliarTipo {
  title: string
  icon: string
  alt: string
  headerBarColor: string
}

export const recordVisitaDomiciliar: Record<TipoVisitaDomiciliarEnum, VisitaDomiciliarTipo> = {
  [TipoVisitaDomiciliarEnum.INDIVIDUAL]: {
    title: 'Visita individual',
    headerBarColor: orange.c60,
    alt: 'Ícone da visita individual',
    icon: IconeVisitaIndividual,
  },
  [TipoVisitaDomiciliarEnum.FAMILIAR]: {
    title: 'Visita Familiar',
    headerBarColor: pink.c60,
    alt: 'Ícone da visita familiar',
    icon: IconeVisitaFamiliar,
  },
  [TipoVisitaDomiciliarEnum.INDEFINIDA]: {
    title: 'Visita indefinida',
    alt: 'Ícone da visita indefinida',
    headerBarColor: green.c70,
    icon: IconeVisitaIndefinida,
  },
}
export const classificacaoVulnerabilidadeRecord: Record<ClassificacaoVulnerabilidadeFamiliar, string> = {
  [ClassificacaoVulnerabilidadeFamiliar.HABITUAL]: 'Habitual',
  [ClassificacaoVulnerabilidadeFamiliar.SUGESTIVA]: 'Sugestiva',
  [ClassificacaoVulnerabilidadeFamiliar.INEQUIVOCA]: 'Inequívoca',
}

export const grauSugestivoRecord: Record<GrauSugestivoVulnerabilidadeFamiliar, string> = {
  [GrauSugestivoVulnerabilidadeFamiliar.HABITUAL]: 'Habitual',
  [GrauSugestivoVulnerabilidadeFamiliar.BAIXA]: 'Grau baixo',
  [GrauSugestivoVulnerabilidadeFamiliar.MEDIA]: 'Grau médio',
  [GrauSugestivoVulnerabilidadeFamiliar.MAXIMA]: 'Grau máximo',
}

export const CONTEXTO_FAMILIA_BOLSA_FAMILIA_TOOLTIP_TEXT =
  'Um cidadão desta família consta como beneficiário do Bolsa Família na vigência mais recente importada. Verifique o acompanhamento das condicionalidades de saúde.'

export const JUSTIFICATIVA_VISUALIZAR_PRONTUARIO_BY_PRONTUARIO_FAMILIAR =
  'Justificativa gerada automaticamente para visualizar o prontuário individual a partir do prontuário familiar.'
